// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_2MulS","visuallyhidden":"_2lSpG","hide-text":"_2YKnY","center":"_3zG0n","noprint":"_1TU4L","root":"_16Y1H","contentContainer":"_2tFI8","aboutvg":"_3Ak3z","lighthr":"_3BM0S","darkhr":"_2QfDE","contactButton":"_1JSiB"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/theme/aboutvg/default.scss
 ** module id = 974
 ** module chunks = 2
 **/